'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attributeLead = attributeLead;

var _noAuthApiClient = require('../utils/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINT = '/acquisition/v1/partner/lead-attribution';

function attributeLead(params) {
  var hubId = params.hubId,
      email = params.email,
      firstName = params.firstName,
      lastName = params.lastName,
      domain = params.domain,
      company = params.company,
      didShowPartnerPrivacy = params.didShowPartnerPrivacy;


  return _noAuthApiClient2.default.post(API_ENDPOINT, {
    data: {
      notification: { hubId: hubId },
      attribution: {
        email: email,
        firstName: firstName,
        lastName: lastName,
        domain: domain,
        company: company,
        didShowPartnerPrivacy: didShowPartnerPrivacy
      }
    }
  });
}